<template>
  <div class="login">
    <div class="login-frame">
      <div class="title"><span>X</span>Bed OMS</div>
      <p>XBED 运营管理平台</p>
      <div class="input-frame">
        <Form ref="formInline" :model="formInline" :rules="ruleValidate">
          <FormItem prop="user">
            <Input type="text" v-model="formInline.user" placeholder="用户名">
              <Icon type="ios-person-outline" slot="prepend"></Icon>
            </Input>
          </FormItem>
          <FormItem prop="password">
            <Input type="password" v-model="formInline.password" placeholder="密码">
              <Icon type="ios-locked-outline" slot="prepend"></Icon>
            </Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="handleSubmit()" :loading="btnLoading" long>登录</Button>
          </FormItem>
        </Form>
      </div>
    </div>

  </div>
</template>

<script>
import Utils from "../utils";
import API from "../api";
import {STORE_KEY} from '../constants'

export default {
  async created() {
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.headerENV = Utils.aliHeaderEnv(this.env)
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
  },
  data() {
    return {
      formInline: {
        user: "",
        password: ""
      },
      ruleValidate: {
        user: [
          { required: true, message: "用户名不能为空", trigger: "blur" }
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { type: 'string', min: 6, message: '密码不能少于6字', trigger: 'blur' }
        ]
      },
      btnLoading: false
    }
  },
  methods: {
    async handleSubmit() {
      let isValid = true;
      this.$refs.formInline.validate(valid => {
        isValid = valid;
      });
      if (!isValid) return;
      this.btnLoading = true;
      let resp = (await this.submitLogin(
        this.formInline.user,
        this.formInline.password,
        this.env
      )).data;

      if (resp.retcode != 1) {
        this.$Notice.error({
          title: "登录失败",
          desc: resp.retmsg
        });
      } else {
        let gatewayLoginResp = (await this.loginWithGateway(
          this.formInline.user,
          this.formInline.password,
          this.env
      )).data;
        if(gatewayLoginResp.retCode){
          this.$Notice.error({
            title: "登录失败",
            desc: gatewayLoginResp.msg
          });
        return
        } else {
          let respAli = (await API.omsAPI[this.env].clientServer.gatewayAliLogin({username:this.formInline.user,password:this.formInline.password},{'x-ca-stage':this.headerENV,'X-Client-Type':5})).data;
          if(respAli.retCode){
            this.$Notice.error({
              title: "登录失败",
              desc: respAli.msg
            });
            return
          } else {
            this.$Notice.success({
              title: "登录成功"
            });
          }
          const userPermissions = Utils.parsePermissions(gatewayLoginResp.menuList)
          Utils.setToStore(STORE_KEY.STORE_KEY_PERMISSIONS,userPermissions) // 把用户权限保存
          Utils.saveToLocalStorage("vue-token", gatewayLoginResp.token);
          Utils.saveToLocalStorage("vue-userid", gatewayLoginResp.user.id);
          Utils.saveToLocalStorage("vue-username", gatewayLoginResp.user.username);
          Utils.saveToLocalStorage("Author-token", respAli.token);
        }

        this.$router.replace({path:'/app'})
      }
      this.btnLoading = false;
    },
    submitLogin(user, password, env) {
      return API.omsAPI[env].php.login(
        user,
        password
      );
    },
    /**
     * gateway 登录
     */
    loginWithGateway(user, password, env){
      return API.omsAPI[env].user.login(
        user,
        password
      );
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  height: 100vh;
  background-color: #303030;
  display: flex;
  justify-content: center;
  align-items: center;
  .login-frame {
    width: 400px;
    height: 350px;

    .title {
      width: 100%;
      text-align: center;
      font-size: 60px;
      color: white;
      &+p {
        text-align: center;
        color: white;
      }
      span{
        color: #00fff0
      }
    }

    .input-frame {
      margin-top: 20px;
      border-radius: 4px;
      background-color: #fff;
      padding: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue